module.exports = __webpack_public_path__ + "static/media/landing-background.9faf4d18.jpg";